export default __webpack_public_path__ + "static/media/toxin.f8c201ff.png";